function UploadController($uibModal, fileService, toasterService, userService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.hasFileUpload = userService.hasFileUpload();
  };

  ctrl.openUploadModal = fileDesc => {
    const modalInstance = $uibModal.open({
      component: 'uploadModal',
      resolve: {
        fileDesc: function () {
          return fileDesc;
        },
      },
    });

    modalInstance.result.then(() => {
      // User pressed 'Accept' in the upload modal.
      ctrl.onSave(); // Refresh the packages list.
    }, () => {
      // User pressed 'Reject' in the upload modal, do nothing.
    });
  };

  ctrl.onFileUpload = async (file) => {
    const response = await fileService.upload(file);
    let responseData = null;
    if (response.statusCode === 400) { 
      toasterService.error('File upload error', file.name + ' has already been uploaded. Delete the existing before uploading a new one.');
      return;
    }
    if (response.statusCode === 200) {
      responseData = JSON.parse(response.data);
    }
    if (response.statusCode !== 200 || !responseData.fileInfoJson.header) {
      if (response.headers.error) {
        let errorObj = JSON.parse(response.headers.error);
        if (errorObj) {
          const firstError = Object.entries(errorObj)[0];
          const badFileOrFieldName = firstError[0];
          const errorMessage = firstError[1];
          toasterService.error('File upload error', badFileOrFieldName + ' ' + errorMessage);
        }
      } else if (response.statusCode === 422) {
        toasterService.error('File upload error', 'File could not be parsed');
      } else {
        toasterService.error('File upload error', 'Failed to upload package');
      }
      ctrl.onRejectUpload(responseData.packageId);
    } else if (response.data) {
      const fileDesc = {
        version: responseData.fileInfoJson.header.version,
        install_parent: responseData.fileInfoJson.header.install_parent,
        install_type: responseData.fileInfoJson.header.install_type,
        module_family_name: responseData.fileInfoJson.header.module_family_name,
        package_filename: responseData.fileInfoJson.header.package_filename,
        date_created: DateTime.fromISO(responseData.fileInfoJson.header.date_created).toFormat('DDD'),
        installation_min: responseData.fileInfoJson.header.installation.minimum_duration,
        installation_max: responseData.fileInfoJson.header.installation.maximum_duration,
        polling_interval: responseData.fileInfoJson.header.installation.polling_interval,
        file_set: responseData.fileInfoJson.file_set,
        install_script_name: responseData.fileInfoJson.install_script ? responseData.fileInfoJson.install_script.filename : undefined,
        install_script_hash: responseData.fileInfoJson.install_script ? responseData.fileInfoJson.install_script.hash : undefined,
        fileId: responseData.packageId
      };
      ctrl.openUploadModal(fileDesc);
    }
  };

  ctrl.onRejectUpload = async (packageId) => {
    const headerApproval = {
      id: packageId,
      status: 'rejected',
    };

    try {
      await fileService.acceptUpload(headerApproval);
    }
    catch (err) {
      console.error('Error on request', err);
    }
  };

  ctrl.fileSelected = (event, files) => {
    if (!files || files.length === 0) return;
    ctrl.onFileUpload(files[0]);
  };
}

angular
  .module('package-management.module')
  .controller('UploadController', UploadController);
